import { OverrideToken } from 'antd/es/theme/interface';

import variables from '../UIConfigProvider.module.scss';

export const Tabs: OverrideToken['Tabs'] = {
  // colorPrimaryTextActive: 'red',
  itemActiveColor: '#111111',
  itemHoverColor: variables.clrPalettePrimary,
  itemSelectedColor: variables.clrPalettePrimary,
  inkBarColor: variables.clrPalettePrimary,
  horizontalMargin: '0',
};
